export enum TypeResumenEnum {
    rtn =   'RTN',
    apv =   'APV',
    bis =   '57BIS',
}